export const CMS_PET_GENERAL_TYPE = 'pet-profile';
export const CMS_FOOD_FINDER_GENERAL_TYPE = 'foodfinder';

export const CMS_CAT_SELECTION_KEY = 'cat';
export const CMS_DOG_SELECTION_KEY = 'dog';
export const CMS_SMALL_PET_SELECTION_KEY = 'small_pet';
export const CMS_REPTILE_SELECTION_KEY = 'reptile';
export const CMS_HORSE_SELECTION_KEY = 'horse';
export const CMS_FISH_SELECTION_KEY = 'fish';
export const CMS_FARM_ANIMAL_SELECTION_KEY = 'farm_animal';
export const CMS_BIRD_SELECTION_KEY = 'bird';

/* NOTE Age Classification is not actively being used but good to have on file */
// Age Classification of Dog Pet Type
export const DOG_YOUNG_YEARS = 1;
export const DOG_ADULT_YEARS = 8;
export const DOG_SENIOR_MIN_YEARS = 8;

// Age Classification of Cat Pet Type
export const CAT_YOUNG_YEARS = 1;
export const CAT_ADULT_YEARS = 6;
export const CAT_SENIOR_MIN_YEARS = 6;

// Other pages
export const FOOD_FINDER_ZONE = 1;
export const PET_PAGE_ZONE = 1;
